<template>
  <v-dialog v-model="intDialogVisible" persistent max-width="500px">
    <v-card>
      <v-toolbar flat dense dark >
        <v-toolbar-title>{{ options.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click.stop="show=false" flat icon><v-icon dark>close</v-icon></v-btn>
      </v-toolbar>
      <div class="pl-4 pr-4 pt-2 pb-2">
        <form name="schedule-form" autocomplete="off">
          <div v-if="errors.length" class="fondo">
            <span id="spanError">Comprueba los siguientes errores:</span>
            <ul>
              <li
                v-for="error in errors"
                v-bind:key="error.id"
                class="blanco">
                {{ error }}
              </li>
            </ul>
          </div>
          <v-text-field
            prepend-icon="build"
            name="recurso"
            type="text"
            label="Nombre"
            v-model="name"
          ></v-text-field>
        </form>
        <v-flex xs12 lg6 lg-offset3 align="center">
          <v-btn v-if="options.modificar" dark @click="modificarTipo()">{{ options.btnName }}</v-btn>
          <v-btn v-else dark @click="crearTipo()">{{ options.btnName }}</v-btn>
        </v-flex>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable */
  import Shared from "../../services/Shared";
  import moment from 'moment';

  export default {
    data() {
      return {
        name: '',
        errors: []
      }
    },
    props: ['dialog', 'options'],
    computed: {
      intDialogVisible: {
        get() {
          if(this.dialog){
            if(typeof this.options.item !== "undefined"){
              this.name = this.options.item.name
            }
          }
          return this.dialog
        }
      },
      show:{
        get(){

        },
        set(value) {
          if (!value) {
            this.limpiar();
            this.$emit('close')
          }
        }
      }
    },
    methods: {
      validar(){
        let flag = true;
        this.errors = [];
        if(this.name == ''){
          flag = false
          this.errors.push('El nombre no puede estar vacío')
        }
        return flag;
      },
      limpiar(){
        this.name = '';
        this.errors = [];
      },
      modificarTipo(){
        if(this.validar()){
          let items = {
            'id': this.options.item.id,
            'name': this.name,
            'modificar': true
          }
          this.$emit('clicked', items)
          this.limpiar();
          this.$emit('close')
        }
      },
      async crearTipo(){
        if(this.validar()){
          let items = {
            'name': this.name,
            'modificar': false
          }
          this.$emit('clicked', items)
          this.limpiar();
          this.$emit('close')
        }
      }
    }
  }
</script>

<style scoped>
  .fondo{
    background-color: #ff5252;
    border-radius: 15px;
  }
  .blanco{
    color: white;
  }
  #spanError{
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialogs/DialogType.vue